import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  setSelectedReseller,
  setIsAssemblyAllowed,
  setWithAssembly,
} from '../Actions/Checkout.action';

import Checkout from '../Components/Checkout/Checkout';

const CheckoutContainer = (props = {}) => <Checkout {...props} />;

CheckoutContainer.propTypes = {
  checkout: PropTypes.object,
  cart: PropTypes.object,
  setSelectedReseller: PropTypes.func,
};

const mapStateToProps = (state) => {
  const { checkout, cart } = state;
  return {
    checkout,
    cart,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedReseller: (pickedStore) => {
      const pickedStoreClone = pickedStore ? { ...pickedStore } : null;
      let organizationId = null;

      if (pickedStoreClone && pickedStoreClone.organization) {
        organizationId = pickedStoreClone.organization;
      }

      // Check if pickedStoreClone is not null and not an assembly
      if (pickedStoreClone && !pickedStoreClone.isAssembly) {
        dispatch(setWithAssembly(true));
      }

      // Safely handle the boolean check for isAssembly
      const isAssemblyAllowed = !!(
        pickedStoreClone && pickedStoreClone.isAssembly
      );
      dispatch(setIsAssemblyAllowed(isAssemblyAllowed));

      // Dispatch organizationId (which could be null)
      dispatch(setSelectedReseller(organizationId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutContainer);
